import { useEffect } from "react";

const SCRIPT_SRC = "https://clients.heyblueheron.com/embed/onyx_professional_plumbing.js";

/**
 * Recent Work — live job check-in feed from the Blue Heron client portal.
 * Renders the widget container and injects the embed script once.
 */
export const RecentWork = () => {
  useEffect(() => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section className="py-24 bg-gradient-dark noise-overlay">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <span className="text-primary font-semibold tracking-wider uppercase text-sm">
            On The Job
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-4 mb-4">Recent Work</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Our latest completed jobs across Gulf Shores, Orange Beach, Foley and the rest of
            Baldwin County.
          </p>
        </div>
        <div className="max-w-5xl mx-auto" id="bh-worklog" />
      </div>
    </section>
  );
};
